angular.module('dnecom')
    .controller('ProductProcessAttributesController', ["$scope", "$document", "notifications", "$http", "$timeout", "ProductAttributesUtils", "SizeProfileUtils", "wizardModal", function ProductProcessAttributesController($scope, $document, notifications, $http, $timeout, ProductAttributesUtils, SizeProfileUtils, wizardModal) {
        $scope.sizeProfiles = TemplateData.value('sizeProfiles');
        $scope.colorProfiles = TemplateData.value('colorProfiles');

        $scope.selectedColorProfile = {};
        $scope.sizeProfile = {};
        $scope.sizeProfile.current = TemplateData.value('currentSizeProfile');
        $scope.sizeProfile.selected = $scope.sizeProfile.current;

        $scope.attributes = [];
        $scope.addingAttribute = false;
        $scope.updatingAttribute = [];
        $scope.removingAttribute = [];

        $scope.$on('avuis:removed', function ($event, value) {
            notifications.success('Value "' + (value.name ? value.name : value.value) + '" removed.');
        });

        $scope.$on('avuis:removed:failed', function ($event, value) {
            notifications.danger('Request error');
        });

        $scope.$on('avuis:added:failed', function ($event, value) {
            if (value.attributeId) {
                $scope.attributes.forEach(function (attribute) {
                    if (attribute.id == value.attributeId) {
                        let removeIndex = attribute.values.map(function(item) { return item.value; }).indexOf(value.item.value);
                        if (removeIndex >= 0) {
                            attribute.values.splice(removeIndex, 1);
                        }
                    }
                })
            }
            if (value.error && value.error.message) {
                notifications.danger(value.error.message);
            } else {
                notifications.danger('Request error');
            }
        });

        $scope.$on('avuis:activate', function ($event, $select, attributeId) {
            angular.forEach($scope.attributes, function (attribute) {
                if (attribute.id == parseInt(attributeId)) {
                    if (attribute.type != 'color' && attribute.type != 'size') {
                        return;
                    }

                    $event.stopPropagation();

                    if (attribute.type == 'size') {
                        $timeout(function () {
                            attribute.showSizeProfile = true;
                        });
                    } else if (attribute.type == 'color') {
                        $scope.hideColorSelectors();
                        $scope.hideAttributeImagesSelector();

                        $timeout(function () {
                            attribute.showColorSelector = true;
                        });
                    }
                }
            });
        });

        $http
            .get(
                Routing.generate('products_attributes_get', {
                    id: $scope.store.id,
                    productId: $scope.product.id
                })
            )
            .then(function (response) {
                if (response.data.success) {
                    $scope.attributes = response.data.attributes;
                    $scope.fillSelectedColorProfile();
                    $scope.$emit('product.variants.changed', response.data.variants);
                } else {
                    notifications.danger(response.data.message);
                }
            }, function () {
                notifications.danger('Request error');
            });

        $scope.attributeTypeSelectorEnabled = false;
        $scope.selectedAttributeValue = false;
        $scope.selectedAttribute = false;
        $scope.linkedImages = [];

        $scope.predefinedColors = ProductAttributesUtils.getDefaultColors();;

        var recentColors = TemplateData.value('recentlyAddedColors');
        $scope.recentlyAddedColors = ProductAttributesUtils.filterColors(recentColors, $scope.predefinedColors);
        $scope.customColors = {};

        $scope.showAttributeTypeSelector = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.attributeTypeSelectorEnabled = true;
        };

        $scope.capitalizeName = function(string){
            return string.charAt(0).toUpperCase() + string.slice(1);
        };

        $scope.addAttribute = function (type, $event) {
            $event.preventDefault();

            if ($scope.addingAttribute) {
                return;
            }

            $scope.addingAttribute = true;

            var attribute = {
                'type': type,
                'name': $scope.capitalizeName(type)
            };

            $http
                .post(
                    Routing.generate('products_attributes_create', {
                        id: $scope.store.id,
                        productId: $scope.product.id
                    }),
                    attribute
                )
                .then(function (response) {
                    if (response.data.success) {
                        var attr = response.data.attribute;
                        $scope.attributes.push(attr);
                        $scope.$emit('product.attributes.changed', $scope.attributes);
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function (response) {
                    notifications.danger('Request error');
                })
                .finally(function () {
                    $scope.addingAttribute = false;
                });

            $scope.hideTypeSelector();
        };

        $scope.updateAttribute = function (attribute) {
            if ($scope.updatingAttribute[attribute.id]) {
                return;
            }

            $scope.updatingAttribute[attribute.id] = true;

            $http
                .post(
                    Routing.generate('products_attributes_update', {
                        id: $scope.store.id,
                        productId: $scope.product.id,
                        attributeId: attribute.id
                    }),
                    attribute
                )
                .then(function (response) {
                    if (response.data.success) {
                        notifications.success('Attribute "' + attribute.name + '" updated.');
                    } else {
                        notifications.danger('Request error');
                    }
                }, function () {
                    notifications.danger('Request error');
                })
                .finally(function () {
                    $scope.updatingAttribute[attribute.id] = false;
                });
        };

        $scope.removeAttribute = function (attribute) {
            if ($scope.removingAttribute[attribute.id]) {
                return;
            }

            $scope.removingAttribute[attribute.id] = true;

            $http
                .delete(
                    Routing.generate('products_attributes_delete', {
                        id: $scope.store.id,
                        productId: $scope.product.id,
                        attributeId: attribute.id
                    })
                )
                .then(function (response) {
                    if (response.data.success) {
                        notifications.success('Attribute "' + attribute.name + '" removed.');
                        $scope.attributes = _.without($scope.attributes, attribute);
                        if (attribute.type == 'size') {
                            $scope.sizeProfile = {};
                        }
                        $scope.$emit('product.attributes.changed', $scope.attributes);
                    } else {
                        notifications.danger('Request error');
                    }
                }, function () {
                    notifications.danger('Request error');
                })
                .finally(function () {
                    $scope.removingAttribute[attribute.id] = false;
                });
        };

        $scope.selectColor = function (attribute, code, name) {
            if ($scope.updatingAttribute[attribute.id] || !code) {
                return;
            }

            code = code.replace('#', '');

            if (!attribute.valueNames || Array.isArray(attribute.valueNames)) {
                attribute.valueNames = {};
            }

            if (!name) {
                if ($scope.predefinedColors[code]) {
                    name = $scope.predefinedColors[code];
                } else {
                    name = code;
                }
            }

            $scope.customColors[code] = name;
            attribute.valueNames[code] = name;
            $scope.recentlyAddedColors[code] = name;

            var duplicated = false;
            attribute.values.forEach(function (item) {
                if (item.value == code) {
                    duplicated = true;
                }
            });

            if (duplicated) {
                notifications.danger('The color is already on the list.');
                return;
            }

            var newValue = {value: code, name: attribute.valueNames[code]};

            $scope.updatingAttribute[attribute.id] = true;
            ProductAttributesUtils.addValue($scope.store.id, $scope.product.id, attribute.id, newValue, function (response) {
                $scope.updatingAttribute[attribute.id] = false;
                var addedValue = response.data.value;

                $scope.$emit('avuis:added', addedValue);

                attribute.values.push(addedValue);

            }, function (error) {
                $scope.updatingAttribute[attribute.id] = false;
                $scope.$emit('avuis:added:failed', { item: newValue, error: error.data });
            });

            attribute.showColorSelector = false;
        };

        $scope.selectSize = function(attribute, sizeName) {
            if ($scope.updatingAttribute[attribute.id] || !sizeName) {
                return;
            }

            var duplicated = false;
            attribute.values.forEach(function(item) {
                if (item.value == sizeName) {
                    duplicated = true;
                }
            });

            if (duplicated) {
                notifications.danger('The size is already on the list.');
                return;
            }

            var newValue = { value: sizeName, name: sizeName };

            $scope.updatingAttribute[attribute.id] = true;
            ProductAttributesUtils.addValue($scope.store.id, $scope.product.id, attribute.id, newValue, function (response) {
                $scope.updatingAttribute[attribute.id] = false;
                var addedValue = response.data.value;
                $scope.sizeProfile.active = $scope.sizeProfile.selected;
                $scope.$emit('avuis:added', addedValue);

                attribute.values.push(addedValue);
            }, function (error) {
                $scope.updatingAttribute[attribute.id] = false;
                $scope.$emit('avuis:added:failed', { item: newValue, error: error.data });
            });

            attribute.showSizeProfile = false;
        };

        $scope.getColorName = function(code, attribute) {
            if (attribute.valueNames && attribute.valueNames[code]) {
                return attribute.valueNames[code];
            }
            return $scope.predefinedColors[code] || $scope.customColors[code] || ('#' + code);
        };

        $scope.hideTypeSelector = function () {
            var result = $scope.attributeTypeSelectorEnabled;

            $scope.attributeTypeSelectorEnabled = false;

            return result;
        };

        $scope.hideColorSelectors = function () {
            var result = false;

            $scope.attributes.forEach(function (attribute) {
                if (attribute.showColorSelector) {
                    attribute.showColorSelector = false;
                    result = true;
                }
            });

            return result;
        };

        $scope.hideSizeSelectors = function () {
            var result = false;

            $scope.attributes.forEach(function (attribute) {
                if (attribute.showSizeProfile) {
                    attribute.showSizeProfile = false;
                    result = true;
                }
            });

            return result;
        };

        $scope.editColor = function(attribute, value, $event) {
            $event.preventDefault();
            $event.stopPropagation();

            if (!value.originalName) {
                value.originalName = value.name;
            }

            wizardModal.open({
                'templateUrl': 'colorNameModal.html',
                'size': 'md',
                'controller': 'ColorNameModalController',
                'resolve': {
                    'colorName': function () {
                        return value.name;
                    }
                }
            }).result.then(function (name) {
                if (!name) {
                    return;
                }

                $http
                    .post(
                        Routing.generate('products_attributes_values_update', {
                            id: $scope.store.id,
                            productId: $scope.product.id,
                            attributeId: attribute.id,
                            valueId: value.id
                        }),
                        {
                            name: name,
                            originalName: value.originalName
                        }
                    )
                    .then(function (response) {
                        if (response.data.success) {
                            value.name = name;
                            attribute.valueNames[value.value] = name;
                            notifications.success('Color name successfully updated.');
                        } else {
                            notifications.danger(response.data.message || 'Request error');
                        }
                    }, function () {
                        notifications.danger('Request error');
                    })
                ;
            });
        };

        $scope.linkAttributeImages = function (attribute, item) {
            if ($scope.updatingAttribute[attribute.id]) {
                return;
            }

            if ($scope.product.gallery.length) {
                $scope.hideAttributeImagesSelector();
                $scope.updateLinkedImages();
                $scope.selectedAttributeValue = item;
                $scope.selectedAttribute = attribute;
                $scope.productGallery = $scope.splitGallery($scope.product.gallery);
                attribute.attributeImageSelector = true;
            }
        };

        $scope.imageAlreadyLinked = function (media) {
            var find = false;
            var ret = false;

            if ($scope.selectedAttributeValue && _.isArray($scope.selectedAttributeValue.images)) {
                $scope.selectedAttributeValue.images.forEach(function (image) {
                    if (image.id == media.id) {
                        ret = true;
                        return;
                    }
                });

                if (ret) {
                    return false;
                }
            }

            $scope.linkedImages.forEach(function (id) {
                if (id == media.id) {
                    find = true;
                    return;
                }
            });
            return find;
        };

        $scope.imageLinkedGeneral = function (media) {
            var find = false;

            $scope.attributes.forEach(function (attribute) {
                if (attribute.type == "style") {
                    attribute.values.forEach(function (value) {
                        if (!value || !value.hasOwnProperty('images')) {
                            return;
                        }

                        value.images.forEach(function (image) {
                            if(image.id == media.id){
                                find = true;
                            }
                        })
                    });
                }
            });

            if ($scope.selectedAttributeValue && _.isArray($scope.selectedAttributeValue.images)) {
                $scope.selectedAttributeValue.images.forEach(function (image) {
                    if (image.id == media.id) {
                        find = false;
                    }
                });
            }

            return find;
        };

        $scope.attributeImageSrc = function (item) {
            if (item && item.images && item.images.length) {
                return $scope.getMediaSrc(item.images[0]);
            }
            return false;
        };

        $scope.updateLinkedImages = function () {
            $scope.attributes.forEach(function (attribute) {
                if (attribute.type != "color") {
                    return;
                }

                attribute.values.forEach(function (value) {
                    if (!value.images) {
                        return;
                    }

                    value.images.forEach(function (image) {
                        var index = $scope.linkedImages.indexOf(image.id);

                        if (index == -1) {
                            $scope.linkedImages.push(image.id)
                        }
                    })
                });
            });
        };

        $scope.removeFromLinkedImages = function (id) {
            var index = $scope.linkedImages.indexOf(id);
            if (index > -1) {
                $scope.linkedImages.splice(index, 1);
            }
        };

        $scope.hideAttributeImagesSelector = function () {
            $scope.attributes.forEach(function (attribute) {
                if (attribute.attributeImageSelector) {
                    attribute.attributeImageSelector = false;
                }
            });
            $scope.selectedAttributeValue = false;
            $scope.selectedAttribute = false;
        };

        $scope.attrValHasImage = function (image) {
            if (!$scope.selectedAttributeValue) {
                return false;
            }

            for (var i in $scope.selectedAttributeValue.images) {
                if ($scope.selectedAttributeValue.images[i].id == image.id) {
                    return true;
                }
            }

            return false;
        };

        $scope.selectAttributeImage = function (image) {
            var value = $scope.selectedAttributeValue;

            if (!value) {
                notifications.danger('Invalid attribute value. Please reload page and try again.');
                return;
            }

            if ($scope.imageLinkedGeneral(image)) {
                return;
            }

            var removeId = false;
            if (value.hasOwnProperty('images') && value.images.length) {
                removeId = value.images[0].id;
            }

            if ($scope.attrValHasImage(image)) {
                $http
                    .delete(Routing.generate('products_attributes_values_images_detach', {
                        id: $scope.store.id,
                        productId: $scope.product.id,
                        attributeId: $scope.selectedAttribute.id,
                        valueId: value.id,
                        mediaId: image.id
                    }))
                    .then(function (response) {
                        if (response.data.success) {

                            $scope.removeFromLinkedImages(image.id);

                            value.images = value.images.filter(function (img) {
                                return (img.id != image.id);
                            });
                        } else {
                            notifications.danger(response.data.message ? response.data.message : 'Request error');
                        }
                    }, function () {
                        notifications.danger('Request error');
                    });

            } else {

                if ($scope.imageAlreadyLinked(image)) {
                    return;
                }

                $http
                    .post(
                        Routing.generate('products_attributes_values_images_attach', {
                            id: $scope.store.id,
                            productId: $scope.product.id,
                            attributeId: $scope.selectedAttribute.id,
                            valueId: value.id
                        }),
                        {
                            media: image.id
                        }
                    )
                    .then(function (response) {
                        if (response.data.success) {
                            value.images = [image];

                            if (removeId) {
                                $scope.removeFromLinkedImages(removeId);
                            }
                        } else {
                            notifications.danger(response.data.message ? response.data.message : 'Request error');
                        }
                    }, function () {
                        notifications.danger('Request error');
                    });
            }
        };

        $scope.splitGallery = function (gallery) {
            var result = {
                row1: [],
                row2: []
            };

            if (gallery.length < 4) {
                result.row1 = gallery;
            } else {
                var range = Math.ceil(gallery.length / 2);
                result.row1 = gallery.slice(0, range);
                result.row2 = gallery.slice(range, gallery.length);
            }

            return result;
        };

        $scope.trackAttributeValue = function (value) {
            return value.id || value.value;
        };

        $scope.getSelectChoices = function(attribute) {
            choices = [];

            attribute.values.forEach(function (item) {
                if (item && item.value && choices.indexOf(item.value) == -1) {
                    choices.push(item.value);
                }
            });

            return choices;
        };

        $(window).click(function () {
            if ($scope.hideTypeSelector() || $scope.hideColorSelectors() || $scope.hideSizeSelectors()) {
                $scope.$digest();
            }
        });

        $('body').on('click', '.product-color-selector, .attribute-type-selector, .colorpicker-visible', function (event) {
            event.stopPropagation();
        });

        $scope.getProfileSizes = function (sizeProfile) {
            if ($scope.sizeProfileEmpty(sizeProfile)) {
                return [];
            }

            return SizeProfileUtils.getProfileSizes(sizeProfile);
        };

        $scope.sizeProfileEmpty = function (sizeProfile) {
            var type = typeof sizeProfile;
            return  type == "undefined" || sizeProfile === null || Array.isArray(sizeProfile);
        };

        $scope.isPropertyAdded = function (property) {
            var added = false;
            angular.forEach($scope.attributes, function (attribute) {
                if (attribute.type == property) {
                    added = true;
                }
            });

            return added;
        };

        $scope.isImagesLinkedToAttribute = function (property) {
            return _.find($scope.attributes, function (attribute) {
                if (attribute.type == property) {
                    return _.find(attribute.values, function (value) {
                        return value && value.images && value.images.length;
                    });
                }
                return false;
            });
        };

        $scope.isAllowedAddImagesToAttribute = function (attribute) {
            switch (attribute.type) {
                case 'style':
                    return !this.isImagesLinkedToAttribute('color');
                case 'color':
                    return !this.isImagesLinkedToAttribute('style');
            }

            return true;
        };

        $scope.linkSizeProfile = function () {
            var profile = $scope.sizeProfile.selected;

            $http
                .post(
                    Routing.generate('products_link_size_profile', {
                        storeId: $scope.store.id,
                        productId: $scope.product.id,
                        sizeProfileId: profile.id
                    })
                )
                .then(function (response) {
                    if (response.data.success) {
                        $scope.sizeProfile.active = $scope.sizeProfile.selected;
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function (response) {
                    notifications.danger('Request error');
                });
        };

        $scope.getAvailableSizes = function () {
            var sizeNames = [];
            if ($scope.sizeProfileEmpty($scope.sizeProfile.selected)) {
                sizeNames = SizeProfileUtils.defaultSizes;
            } else {
                sizeNames = $scope.getProfileSizes($scope.sizeProfile.selected);
            }

            return sizeNames;
        };

        $scope.isObjectEmpty = function(object) {
            return angular.equals(object, {});
        };

        $scope.setUpdatingAttribute = function(attributeId, isUpdating) {
            $scope.updatingAttribute[attributeId] = isUpdating;
        }

        $scope.fillSelectedColorProfile = function () {
            $scope.selectedColorProfile = {};
            $scope.colorProfiles.forEach(function (colorProfile) {
                $scope.attributes.forEach(function (attr) {
                    if (attr.colorProfile && attr.colorProfile.id && colorProfile.id == attr.colorProfile.id) {
                        $scope.selectedColorProfile[attr.id] = colorProfile;
                    }
                });
            });
        };

        $scope.linkColorProfile = function (attribute, storeId, productId) {
            $scope.updatingAttribute[attribute.id] = true;
            $http
                .post(
                    Routing.generate('products_attributes_attach_color_profile', {
                        id: storeId,
                        productId: productId,
                        attributeId: attribute.id,
                        colorProfileId: $scope.selectedColorProfile[attribute.id].id
                    })
                ).then(function (response) {
                $scope.updatingAttribute[attribute.id] = false;
                var addedValue = response.data.value;

                $scope.$emit('avuis:added', {});
                addedValue.forEach(function (item) {
                    attribute.valueNames[item.value] = item.name;
                    attribute.values.push(item);
                });

            }, function (error) {
                $scope.updatingAttribute[attribute.id] = false;
                $scope.$emit('avuis:added:failed', {});
            });
        };
    }]);